var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextDonationNt600(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 20,
    viewBox: "0 0 96 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92 1.76H15.74V18.3H10.62L7.18 12.62H6.76V18.28H0.84V1.76H6.14L9.48 7.4H9.92V1.76ZM30.602 1.68V7.46H27.182V18.3H20.562V7.46H17.142V1.68H30.602ZM44.1123 7.4L46.1323 9.04V15.42L43.7123 17.68H42.2523V19.3H36.1923V17.68H32.4323V12.98H39.5723V11.96H34.4723L32.4523 10.3V4.24L34.8723 1.98H36.1923V0.5H42.2523V1.98H45.6923V6.38H38.5923V7.4H44.1123ZM61.0838 7.76L62.6238 9.18V16.4L60.5438 18.48H50.3838L48.3038 16.4V3.9L50.9038 1.32H62.1638V6.38H54.2438V7.76H61.0838ZM56.9838 13.66V12.02H54.2438V13.66H56.9838ZM64.5742 16.22V3.68L66.8942 1.3H76.5342L78.8742 3.68V16.22L76.5342 18.46H66.8942L64.5742 16.22ZM70.5542 6.9V12.98H72.8942V6.9H70.5542ZM80.8828 16.22V3.68L83.2028 1.3H92.8428L95.1828 3.68V16.22L92.8428 18.46H83.2028L80.8828 16.22ZM86.8628 6.9V12.98H89.2028V6.9H86.8628Z",
    fill: "#4527A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDonationNt600);
export default __webpack_public_path__ + "static/media/text-donation-NT600.e517788f10d4509d4369c4b5a8ef2c90.svg";
export { ForwardRef as ReactComponent };